import { api } from '@shared/services/api';
import { url } from 'constants/urls';

export interface GuildOfferCheckoutRequestBody {
  beneficiaries: string[]
  country: string
  currency: string
  lastSeenPrice: number
  locale: string
  offerId: string
  paymentType: string
  quantity: number
  chainId: number
}

export const guildOfferCheckout = async (data: GuildOfferCheckoutRequestBody) => {
  const response = await api.post(url.guildOfferCheckout, data);

  return response.data;
};
